import { render } from "./UserProgrammiQuestionario.vue?vue&type=template&id=194edbbd&scoped=true"
import script from "./UserProgrammiQuestionario.vue?vue&type=script&lang=js"
export * from "./UserProgrammiQuestionario.vue?vue&type=script&lang=js"

import "./UserProgrammiQuestionario.vue?vue&type=style&index=0&id=194edbbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194edbbd"]])

export default __exports__